import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";


// Save Buckets ("Save Changes")
const saveBuckets = (buckets) => {

    let isMounted = true;
    const controller = new AbortController();

    const bucketsToInsert = buckets.filter((row) => row.actions === "INSERT");
    const bucketsToUpdate = buckets.filter((row) => row.actions === "UPDATE");
    const bucketsToDelete = buckets.filter((row) => row.actions === "DELETE");


    const insertBuckets = async (bucketsToInsert) => {
        try {
            await axiosPrivate.post("/buckets",
                bucketsToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateBuckets = async (bucketsToUpdate) => {
        try {
            await axiosPrivate.put("/buckets",
                bucketsToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteBuckets = async (bucketsToDelete) => {
        try {
            await axiosPrivate.post("/buckets/delete",
                bucketsToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (bucketsToDelete.length > 0) { deleteBuckets(bucketsToDelete) };
    if (bucketsToInsert.length > 0) { insertBuckets(bucketsToInsert) };
    if (bucketsToUpdate.length > 0) { updateBuckets(bucketsToUpdate) };

};
export default saveBuckets